import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  accent: belongsTo(),
  district: belongsTo(),
  standardsSet: belongsTo(),

  students: hasMany(),
  teachers: hasMany(),

  schoolPartners: hasMany(),
  schoolSubscriptions: hasMany(),
  subscriptionCoordinators: hasMany(),
})
